

import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {

  1: { // Exercise num
    unit: 'Review 4',
    id: 'SB5-V2-PV4-P92-E1',
    audio: '',
    video: '',
    component: T6,
    maxLength: 1,
    isHiddenCheck:true,
    textAlign: 'center',
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page92/E1/Key/answerKey.png',
    inputSize: 25,
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page92/E1/1.jpg' /> </div>
          <div style=" position: absolute; top: 172px; left: 334px; "><input id='0' /></div>
          <div style=" position: absolute; top: 211px; left: 334px; "><input id='1' /></div>
          <div style=" position: absolute; top: 247px; left: 334px; "><input id='2' /></div>
          <div style=" position: absolute; top: 286px; left: 334px; "><input id='3' /></div>
          <div style=" position: absolute; top: 323px; left: 334px; "><input id='4' /></div>
          <div style=" position: absolute; top: 360px; left: 333px; "><input id='5' /></div>
          <div style=" position: absolute; top: 134px; left: 562px; "><input id='6' /></div>
          <div style=" position: absolute; top: 210px; left: 563px; "><input id='7' /></div>
          <div style=" position: absolute; top: 247px; left: 562px; "><input id='8' /></div>
          <div style=" position: absolute; top: 286px; left: 562px; "><input id='9' /></div>
          <div style=" position: absolute; top: 323px; left: 562px; "><input id='10' /></div>
          <div style=" position: absolute; top: 361px; left: 561px; "><input id='11' /></div>
          <div style=" position: absolute; top: 398px; left: 562px; "><input id='12' /></div>
          <div style=" position: absolute; top: 210px; left: 485px; "><input id='13' /></div>
          <div style=" position: absolute; top: 247px; left: 486px; "><input id='14' /></div>
          <div style=" position: absolute; top: 287px; left: 487px; "><input id='15' /></div>
          <div style=" position: absolute; top: 322px; left: 486px; "><input id='16' /></div>
          <div style=" position: absolute; top: 360px; left: 486px; "><input id='17' /></div>
          <div style=" position: absolute; top: 173px; left: 376px; "><input id='18' /></div>
          <div style=" position: absolute; top: 171px; left: 449px; "><input id='19' /></div>
          <div style=" position: absolute; top: 172px; left: 524px; "><input id='20' /></div>
          <div style=" position: absolute; top: 172px; left: 600px; "><input id='21' /></div>
          <div style=" position: absolute; top: 209px; left: 638px; "><input id='22' /></div>
          <div style=" position: absolute; top: 247px; left: 638px; "><input id='23' /></div>
          <div style=" position: absolute; top: 285px; left: 637px; "><input id='24' /></div>
          <div style=" position: absolute; top: 361px; left: 638px; "><input id='25' /></div>
          <div style=" position: absolute; top: 398px; left: 638px; "><input id='26' /></div>
          <div style=" position: absolute; top: 323px; left: 372px; "><input id='27' /></div>
          <div style=" position: absolute; top: 436px; left: 449px; "><input id='28' /></div>
          <div style=" position: absolute; top: 436px; left: 486px; "><input id='29' /></div>
          <div style=" position: absolute; top: 436px; left: 524px; "><input id='30' /></div>


        </div>
        `,
        answer: [
          "e",
          "e",
          "r",
          "f",
          "u",
          "l",

          "o",
          "o",
          "r",
          "c",
          "y",
          "c",
          "l",

          "r",
          "r",
          "i",
          "e",
          "d",

          "l",
          "c",
          "p",
          "e",

          "e",
          "l",
          "a",
          "e",
          "d",


          "s",

          "l",
          "a",
          "n",


        ],
      },
    ],
  },
  2: {
    unit: 'Review 4',
    id: 'SB5-V2-PV4-P92-E2',
    audio: '',
    video: '',
    component: D1,
    padding:0,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page92/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page92/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page92/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page92/E2/3.jpg', input: true, answer: "fountain " },
        { url: 'img/FriendsPlus/Page92/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page92/E2/5.jpg', input: true, answer: "grass" },
        { url: 'img/FriendsPlus/Page92/E2/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page92/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page92/E2/8.jpg', input: true, answer: "path" },
        { url: 'img/FriendsPlus/Page92/E2/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page92/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page92/E2/11.jpg', input: true, answer: "litter" },
        { url: 'img/FriendsPlus/Page92/E2/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page92/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page92/E2/14.jpg', input: true, answer: "garbage can" },
        { url: 'img/FriendsPlus/Page92/E2/15.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page92/E2/16.jpg' },
      ],

    ]
  },

  3: { // Exercise num
    unit: 'Review 4',
    id: 'SB5-V2-PV4-P92-E3',
    audio: '',
    video: '',
    component: T6,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page92/E3/Key/answerKey.png',
    inputSize: 100,
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page92/E3/1.jpg' /> </div>

          <div style=" position: absolute; top: 118px; left: 535px; "><input id='0' /></div>
          <div style=" position: absolute; top: 155px; left: 112px; "><input id='1' /></div>
          <div style=" position: absolute; top: 155px; left: 535px; "><input id='2' /></div>
          <div style=" position: absolute; top: 192px; left: 110px; "><input id='3' /></div>
          <div style=" position: absolute; top: 193px; left: 535px; "><input id='4' /></div>
        </div>
        `,
        answer: [
          "mustn't",
          "must",
          "must",
          "mustn't",
          "mustn't",
        ],
      },
    ],
  },






}
export default json;
